<template>
  <div id="calculation" class="form" :class="$mq">
    <h3>{{ $t("step3.title") }}</h3>
    <div class="section" :class="$mq">
      <div class="title">{{ $t("step3.position.title") }}</div>
      <ValidationObserver ref="observer" v-slot="{ valid }" slim>
        <div class="inline top city center" :class="$mq !== 'mobile' ? 'h-item-margin': ''">
          <label for="zipCode">
            <h4>{{ $t("step3.position.zip-code") }}</h4>
            <ValidationProvider
              rules="required|numeric"
              v-slot="{ errors }"
              :customMessages="{ required: $t('step3.position.required')}"
            >
              <input
                type="text"
                id="zipCode"
                name="zipCode"
                v-model="zipCode"
                class="input"
                @change="getData()"
              />
              <span class="input-error">{{ errors[0] }}</span>
            </ValidationProvider>
          </label>

          <label for="city" class="grow">
            <h4>{{ $t("step3.position.city") }}</h4>
            <select
              id="city"
              name="city"
              class="input"
              v-model="city"
              :disabled="isLoadingCity || isLoadingProviders"
            >
              <option v-for="city in cityList" :key="city" v-bind:value="city">{{ city }}</option>
            </select>
          </label>
        </div>
      </ValidationObserver>

      <div class="container inline center h-item-margin margin no-legend">
        <span class="check-frame">{{ $t(`step3.quote-${$mq}`) }}</span>
        <label for="simulation" class="switch">
          <input type="checkbox" id="simulation" name="simulation" v-model="simulation" />
          <span class="slider"></span>
        </label>
        <span class="check-frame">{{ $t(`step3.calculation-${$mq}`) }}</span>
      </div>
    </div>

    <Providers v-if="!simulation" :loading="isLoadingProviders"></Providers>

    <div class="button inline">
      <button @click="nextStep()" class="stroke">{{ $t('continue') }}</button>
    </div>
  </div>
</template>

<script>
import Providers from "./calculation/Providers";
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      loadingCity: false,
      loadingProviders: false
    };
  },
  computed: {
    ...mapState("calculation", ["cityList", "providersElec"]),
    ...mapGetters("energy", ["hasElec"]),
    isLoadingCity: {
      get() {
        return this.cityList.length > 0 ? this.loadingCity : true;
      }
    },
    isLoadingProviders: {
      get() {
        return this.providersElec.length > 0 ? this.loadingProviders : true;
      }
    },
    zipCode: {
      get() {
        return this.$store.state.calculation.zipCode;
      },
      set(value) {
        this.$store.commit("calculation/setZipCode", value);
      }
    },
    city: {
      get() {
        return this.$store.state.calculation.city;
      },
      set(value) {
        this.$store.commit("calculation/setCity", value);
      }
    },
    simulation: {
      get() {
        return this.$store.state.calculation.simulation;
      },
      set(value) {
        this.$store.commit("calculation/setSimulation", value);

        if (value === false) {
          this.getData();
        }
      }
    }
  },
  methods: {
    nextStep: async function() {
      let isValid = await this.$refs.observer.validate();

      if (isValid) {
        this.$store.commit("calculation/setValid", true);
        this.$store.dispatch("calculation/save");
        this.$router.push({ name: "Contact", query: this.$route.query });
      }
    },
    getData() {
      if (this.simulation) {
        this.getCity();
      } else {
        this.getProviders();
      }
    },
    async getCity() {
      try {
        this.loadingCity = true;
        await this.$store.dispatch("calculation/getCity");
        this.loadingCity = false;
        this.loadingProviders = false;
      } catch (error) {
        this.loadingCity = false;
        console.log(error);
      }
    },
    async getProviders() {
      try {
        this.loadingProviders = true;
        await this.$store.dispatch("calculation/getProviders");
        this.loadingProviders = false;
      } catch (error) {
        console.log(error);
        this.loadingProviders = false;
      }
    }
  },
  created() {
    if(this.zipCode) this.getData();
    window.scrollTo(0,0);
  },
  components: { Providers }
};
</script>

<style lang="scss" scoped>
.city {
  margin: auto 10%;
  .grow {
    min-width: 250px;
    max-width: 400px;
    .input {
      width: 100%;
    }
  }
}

.check-frame {
  font-weight: bold;
}

select:disabled {
  background: #f5f5f5;
}
</style>


// WEBPACK FOOTER //
// src/views/Calculation.vue